/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PublicExternalTagReferenceDto } from './PublicExternalTagReferenceDto';
import type { PublicFilterNotificationRuleMonitorScopeConditionDto } from './PublicFilterNotificationRuleMonitorScopeConditionDto';

export type PublicTagFilterNotificationRuleMonitorScopeConditionDto = (PublicFilterNotificationRuleMonitorScopeConditionDto & {
    /**
     * Operator of the condition
     */
    operator?: PublicTagFilterNotificationRuleMonitorScopeConditionDto.operator;
    /**
     * List of the tag references in the condition
     */
    tags?: Array<PublicExternalTagReferenceDto>;
} & {
    /**
     * Operator of the condition
     */
    operator: PublicTagFilterNotificationRuleMonitorScopeConditionDto.operator;
    /**
     * List of the tag references in the condition
     */
    tags: Array<PublicExternalTagReferenceDto>;
});

export namespace PublicTagFilterNotificationRuleMonitorScopeConditionDto {

    /**
     * Operator of the condition
     */
    export enum operator {
        IS = 'IS',
        IS_NOT = 'IS_NOT',
    }


}
